import Api from 'services/api';

export const lockRessources = (object_id, workflow_id) => {
  return new Promise((resolve, reject) => {
    Api.post(`/locks`, {
      object_id,
      workflow_id,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteLock = (id) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/locks/${id}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const checkLockOwner = (object_id) => {
  return new Promise((resolve, reject) => {
    Api.get(`/locks/${object_id}`)
      .then((response) => {
        resolve(response); // 200 si on est propriétaire ou si pas de lock
      })
      .catch((error) => {
        reject(error); // 423 si l'objet est verrouillé par quelqu'un d'autre
      });
  });
};
